export default __webpack_public_path__ + "static/wemoney-sl-cs-2022-6753376de9be470366b6444db89db588.svg";